import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { textPlaceHolder } from "../../../helpers/placeholders";
import { DraggableComponentTypes, } from "../../../types/draggable";
import DraggableComponent from "../DraggableComponent";
const DraggableListItem = ({ item: { props, id, children }, elementId, ...rest }) => {
    const iconChild = children?.find((c) => c.type === DraggableComponentTypes.Icon);
    return (_jsx("li", { className: props?.className, "editor-key": id, "editor-has-childs": (children?.length > 0).toString(), ...rest, children: children && children.length > 0 ? (_jsx(_Fragment, { children: children?.map((item) => (_jsx(DraggableComponent, { item: item, elementId: elementId }, item.id))) })) : (props?.text || textPlaceHolder.value) }));
};
export default DraggableListItem;
//# sourceMappingURL=DraggableListItem.js.map